import axios from "axios";
import { useState } from "react";
import { ArticleInfo } from "../../Modeles/ArticleModel";
import { useParams } from "react-router-dom";

export default function DetailCommandeService(id:any){
    const MagasinId = localStorage.getItem('MagasinId');

    // const {id}= useParams();    
    const urlShowProductAdmin = `${process.env.REACT_APP_PHP_APP_URL}/admin/historique/${id}`;
    const urlShowProduct = `${process.env.REACT_APP_PHP_APP_URL}/magasins/${MagasinId}/historique/${id}`;
    const getCommande=()=>{
        return (axios.post(urlShowProduct));
    }
    const getCommandeDetailsAdmin=()=>{
        return (axios.get(urlShowProductAdmin));
    }
    return {
        getCommande,
        getCommandeDetailsAdmin,
    }
}